import { init as initApm } from '@elastic/apm-rum'
import { setAmpUrl } from '@/config/env'
import { Domain } from '@com.capgemini.cn/crbr-api-server'

const urlData = {
  'cpmcust.crbeverage.com': 'pro', // prod
  'cpmcust-uat.crbeverage.com': 'uat', // uat
  'fat': 'fat',
  'dev': 'dev'
}

// 初始化埋点
function init (data, env) {
  initApm({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: 'cpm-cust-wechat',

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: data,

    // Set service version (required for sourcemap feature)
    serviceVersion: '',
    environment: env
  })
}

export const requestAmpUrl = () => { // 动态获取埋点地址
  return new Promise((resolve, reject) => {
    Domain.getEnvUrl('commonUrl', urlData, undefined, true).then(res => {
      if (res.data) {
        const ampUrl = res.data['apm-rum-server']
        setAmpUrl(ampUrl)
        init(ampUrl, res.env)
        resolve()
      }
    }).catch(err => {
      alert(err.msg)
    })
  })
}



// WEBPACK FOOTER //
// ./src/plugin/monitoring.js